import { motion } from 'framer-motion';
import { TESTIMONIALS } from '@/data/site';
import { Star } from 'lucide-react';

const EASE = [0.16, 1, 0.3, 1];

export default function Testimonials() {
  return (
    <section className="relative bg-white py-28 md:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#1D4ED8] flex items-center gap-3">
              <span className="w-8 h-px bg-[#1D4ED8]" /> Kind words
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display uppercase text-[#0A0A0A] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              4.9 out of 5, from<br />people who lived through it.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.07 }}
              className={`relative border border-black/10 p-8 md:p-10 bg-black/[0.02] ${i % 3 === 0 ? 'md:translate-y-8' : ''}`}
            >
              <div className="absolute -top-3 left-8 bg-[#1D4ED8] px-2 py-0.5 font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#0A0A0A]">
                Verified
              </div>
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#1D4ED8] text-[#1D4ED8]" />
                ))}
              </div>
              <blockquote className="font-display uppercase text-[#0A0A0A] text-2xl md:text-3xl leading-tight tracking-tight">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between">
                <div>
                  <div className="text-[#0A0A0A] font-medium">{t.name}</div>
                  <div className="font-mono-label text-[10px] tracking-[0.22em] uppercase text-[#0A0A0A]/60 mt-1">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
